import { useEffect, useState } from 'react';

function useVisibility(ref) {
  const [isVisible, setIsVisible] = useState(false);
  const [hasVisible, setHasVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (hasVisible || !ref.current) return;

      const rect = ref.current.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (visible) {
        setIsVisible(true);
        setHasVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial visibility

    return () => window.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return isVisible;
}

export default useVisibility;
